import { defineStore } from 'pinia';
import { ref } from 'vue';

export const usePublicProfileStore = defineStore('publicProfile', () => {
  const profileSlug = ref<string>();
  const profileUuid = ref<string>();

  return {
    profileSlug,
    profileUuid,
  };
});
